export enum Routes {
    BASE = '/',
    MAP = '/map',
    NOT_SUPPORTED = '/not-supported',
    LOADING = '/laden',
}
